import * as req from 'api/actions';
import * as c from './constant';

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionList = (payload = { module_type: 'MC' }, callback) =>
  req.list(
    c.GET_TRANSACTION,
    '/api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const getPhoto = (payload = {}, callback) =>
  req.item(
    c.GET_PHOTO,
    '/api/v1/administrators/marriage_certificates/transaction_histories/photo',
    callback,
    payload
  );

export const getMarriageCertificatesArchive = (payload = {}, callback) =>
  req.list(
    c.GET_MARRIAGE_ARCHIVE,
    '/api/v1/administrators/marriage_certificates/transaction_histories',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `/api/v1/administrators/transaction_histories/marriage_certificates/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const updateMarriageCertificate = (id, payload, callback) =>
  req.update(
    c.EDIT_MARRIAGE,
    `/api/v1/administrators/transaction_histories/marriage_certificates/${id}/update_detail`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const onUpdateRegistry = (id, payload, callback) =>
  req.update(
    c.UPDATE_REGISTRY,
    `/api/v1/administrators/transaction_histories/marriage_certificates/${id}/update_registry`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const qrVerifier = (qr_value, callback) =>
  req.create(
    c.QR_VERIFIER,
    `/api/v1/administrators/transaction_histories/qr_verification?qr_value=${qr_value}`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const manualPaymentApprove = (id, payload, callback) =>
  req.update(
    c.MANUAL_PAYMENT_APPROVE,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment/approve`,
    payload,
    callback
  );

export const manualPaymentReject = (id, payload, callback) =>
  req.update(
    c.MANUAL_PAYMENT_APPROVE,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment/reject`,
    payload,
    callback
  );

export const getLogs = (id, payload, callback) =>
  req.list(
    c.GET_LOGS,
    `/api/v1/administrators/transaction_histories/marriage_certificates/${id}/logs`,
    payload,
    callback
  );

export const applyDiscount = (id, payload, callback) =>
  req.update(
    c.APPLY_DISCOUNT,
    `/api/v1/administrators/transaction_histories/marriage_certificates/${id}/apply_discount`,
    payload,
    callback
  );

export const cancelApplication = (id, payload, callback) =>
  req.create(
    c.CANCEL_APPLICATION,
    `/api/v1/administrators/transaction_histories/marriage_certificates/${id}/cancel_application`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const onCancelAssessment = (id, payload, callback) =>
  req.create(
    c.CANCEL_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/civil_registries/${id}/cancel_assessment`,
    payload,
    callback
  );

export const getPurposeList = (payload, callback) =>
  req.list(
    c.GET_PURPOSE_LIST,
    '/api/v1/administrators/purposes_listing',
    payload,
    callback
  );